// History
import { useHistory } from 'react-router-dom'

// Languages
import { useTranslation } from 'react-i18next'

// Styles
import { TagmeButtonBackStyles } from './styles'

function TagmeButtonBack() {
	// Handle the text translation
	const { t } = useTranslation()

	let history = useHistory()

	const handleBack = () => {
		history.goBack()
	}

	return (
		<TagmeButtonBackStyles>
			<button onClick={handleBack}>
				<i className={`icon tagmeicon tagmeicon-voltar`}></i>
				<span id="label_back_button">{t('Return')}</span>
				<div className="aligner"></div>
			</button>
		</TagmeButtonBackStyles>
	)
}

export default TagmeButtonBack
